import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { resources } from "@/mocks/resources";

export default function ResourceCards() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {resources.map((r) => (
        <Link
          key={r.id}
          to={r.to}
          className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform hover:-translate-y-1"
        >
          <div className="aspect-[4/3] w-full overflow-hidden bg-background-100">
            <img
              src={r.image}
              alt={t(`res.${r.id}.title`)}
              title={`${t("site.name")} ${t(`res.${r.id}.title`)}`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="p-5">
            <h3 className="font-heading text-base font-semibold text-foreground-950">{t(`res.${r.id}.title`)}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t(`res.${r.id}.text`)}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-700">
              {t("res.learnMore")}
              <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"></i>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}